/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveRevenueDtoPage } from '../../models/effective-revenue-dto-page';

export interface ListEffectiveRevenues$Params {
  projectId?: string | null;
  budgetIds?: Array<string>;
  wpIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'inflowDate' | '-inflowDate' | 'totalAmount' | '-totalAmount' | 'budget' | '-budget' | 'budgetName' | '-budgetName' | 'project' | '-project' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listEffectiveRevenues(http: HttpClient, rootUrl: string, params?: ListEffectiveRevenues$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveRevenueDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEffectiveRevenues.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveRevenueDtoPage>;
    })
  );
}

listEffectiveRevenues.PATH = '/v0/effectiveRevenue';
